import { render } from "./SettingsInDefault.vue?vue&type=template&id=3172a282&scoped=true&ts=true&lang=pug"
import script from "./SettingsInDefault.vue?vue&type=script&lang=ts"
export * from "./SettingsInDefault.vue?vue&type=script&lang=ts"

import "./SettingsInDefault.vue?vue&type=style&index=0&id=3172a282&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3172a282"]])

export default __exports__